import { makeQueryKeys } from '@/lib/query-keys';

const _authKeys = makeQueryKeys('auth');

/**
 * Query keys for the auth module.
 * - `me()` is the canonical key for the current user identity (`/auth/me`).
 *   All consumers must use this accessor — never reconstruct the literal,
 *   or mutation invalidations will silently miss reads. Find consumers
 *   with: `git grep authKeys.me`.
 */
export const authKeys = {
  ..._authKeys,
  me: (): readonly ['auth', 'detail', 'me'] =>
    _authKeys.detail('me') as readonly ['auth', 'detail', 'me'],
} as const;
